<template>
  <ToastModal
    ref="modal"
    :title="$t('SignUp.StepFive.AddPromoCodeTitle')"
    modal-id="promotion-code-modal"
    show-mobile-footer
  >
    <div v-loading="loading" class="text-gray-600 lg:px-7">
      <form @submit.prevent="onSubmit">
        <div class="px-1 pt-4">
          <span class="promocode-span ota-small-light font-bold" v-text="`${$t('SignUp.StepFive.PromoCode')}:`" />
          <OInput
            id="promotionCode"
            ref="input"
            v-model="promotionCode"
            label=""
            :input-classes="['w-full', 'uppercase', 'ota-subtitle-heavy', 'text-center', 'mb-2', errorClass]"
            :aria-label="$t('SignUp.StepFive.PromoCode')"
            tabindex="0"
            @input="$emit('input', $event)"
            @keydown.enter.prevent="onSubmit"
            @keydown.space.prevent="onSubmit"
          />
          <div v-if="error" class="text-red-400 text-sm flex items-center">
            <OSvg svg="danger" class="inline-block mr-2 fill-red-400" width="20" />
            <div v-text="error" />
          </div>
        </div>
        <div class="text-center mb-1 lg:mt-5">
          <OButton
            variant="secondary"
            class="mb-3 mt-4"
            type="submit"
          >
            {{ $t('SignUp.StepFive.CheckCode') }}
          </OButton>
          <div class="flex justify-center items-center cursor-pointer lg:mb-7" @click="isOpen = !isOpen">
            <span v-t="'SignUp.StepFive.GameRules'" class="ota-body-light" :class="{ 'font-bold': isOpen }" />
            <OSvg svg="arrow-down" class="fill-current text-gray-600 h-4 w-4 ml-2" />
          </div>
        </div>
      </form>
      <div v-if="isOpen">
        <ul class="list-disc px-2 pt-2">
          <li v-for="(rule, i) in gameRules" :key="i" class="ota-small-light mb-6" v-text="rule" />
        </ul>
      </div>
    </div>
    <template v-slot:footer>
      <ToastModalFooter class="w-full" variant="plane" color="black" @click="onModalClose" />
    </template>
  </ToastModal>
</template>

<script>
import ToastModal from '@/components/ToastModal'
import ToastModalFooter from '@/components/ToastModal/ToastModalFooter'
import { togglePageScroll } from '@/utils/general'
const OSvg = () => import('@/components/OSvg')
const OInput = () => import('@/components/OInput')
const OButton = () => import('@/components/OButton')

export default {
  name: 'PromotionCodeModal',
  components: {
    OSvg,
    OInput,
    OButton,
    ToastModal,
    ToastModalFooter
  },
  props: {
    classes: {
      type: Array,
      default: () => ([])
    },
    value: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpen: false,
      promotionCode: this.value
    }
  },
  computed: {
    gameRules () {
      return [0, 1, 2].map(index => this.$t(`SignUp.StepFive.GameRuleLines[${index}]`))
    },
    errorClass () {
      return this.error ? 'has-error' : ''
    }
  },
  methods: {
    onSubmit () {
      togglePageScroll(false)
      this.$emit('submit', { promotionCode: this.promotionCode })
    },
    toggleActivation () {
      this.$refs.modal.toggleActivation()
      this.$refs.input?.$el.querySelector('input').focus()
    },
    onModalClose () {
      this.$refs.modal.onModalClose()
    }
  }
}
</script>

<style lang="postcss" scoped>
.promocode-span {
  @apply text-lg !important;
}

>>> input {
  @apply py-3 text-2xl border-black !important;
}

>>> .promotion-code-modal {
  @apply rounded-lg !important;
  @apply px-9 pt-12;
  top: 22% !important;

  input {
    &.has-error {
      @apply border-red-400 !important;
    }
  }
}

@screen lg {
    >>> .promotion-code-modal {
      @apply pt-15 px-8;
      top: 27% !important;
    }
}

.close {
    @apply absolute text-5xl font-semibold cursor-pointer top-0 right-0 mt-5 mr-8;

    svg {
      @apply fill-black;
    }
}
</style>
